// import Error from 'components/alerts/Error';
import { Info } from 'components/common/form/modules/Info';
import { Text } from 'components/common/form/modules/input/Text';
import { TextArea } from 'components/common/form/modules/input/TextArea';
import { TimezoneSelect } from "components/common/form/modules/input/TimezoneSelect";
import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
import { createCampaign, isSubdomainAvailable } from 'components/graphql/queries';
import { closeModal } from 'components/modal/modules/dispatcher/methods';
import ImageUpload from 'components/upload/ImageUpload';
import React, { useCallback, useEffect, useState } from 'react'
import { Input, Label } from 'reactstrap'
import DatePicker from 'react-datepicker';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import { CloseCircleOutline } from 'react-ionicons'
import { connect } from 'react-redux';
import UserDucks from 'stores/ducks/User.duck';
import "react-datepicker/dist/react-datepicker.css";
// import Slider from '@material-ui/core/Slider';
import { ResponsiveScatterPlot } from '@nivo/scatterplot'

const CreateCampaign: React.FC<{ [label: string]: any }> = (props: any) => {

    const today = new Date()

    const addDays = (date: Date, days: number) => {
        const other = new Date()
        other.setDate(date.getDate() + days)
        return other
    }

    const defaultStart = addDays(today, 7)
    const defaultEnd = addDays(today, 8)

    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [subdomain, setSubdomain] = useState('')
    const [showLeaderboard] = useState(true)    // can't change this for now. Maybe later. 
    const [startTime, setStartTime] = useState(defaultStart)
    const [endTime, setEndTime] = useState(defaultEnd)
    const [timeZone, setTimeZone] = useState(-1 * new Date().getTimezoneOffset() / 60)
    const [agreed, setAgreed] = useState(false)
    const [location, setLocation] = useState<any>(null)
    const [secretLocation, setSecretLocation] = useState(false)
    const [fpBackground, setFpBackground] = useState(undefined)
    const [collectAddress, setCollectAddress] = useState(false)
    const [showFloorplan, setShowFloorplan] = useState(false)
    const [surveyQuestion, setSurveyQuestion] = useState('')
    const [height] = useState(25)
    const [width] = useState(40)
    const [data, setData] = useState([])
    const [imageHeight, setImageHeight] = useState(0)

    const [btnDisabled, setBtnDisabled] = React.useState(false)
    const [createBtnText, setCreateBtnText] = React.useState('CREATE')
    const [hideDisplayTime] = useState(false)

    const onImgLoad = useCallback(({ target: img }) => {
        setImageHeight(img.offsetHeight)
    }, [setImageHeight])

    const [labels] = useState([])
    const [currNode] = useState({ x: -1, y: -1, label: '' })

    const now = new Date()
    const zero = new Date()

    now.setHours(23)
    now.setMinutes(45)
    zero.setHours(0);
    zero.setMinutes(0);

    let flag1 = false;
    let flag2 = false;

    const handleStartChange = useCallback((e) => {
        if (e > endTime) {
            setStartTime(e)
            setEndTime(e)
        } else {
            setStartTime(e)
        }
    }, [endTime, setStartTime, setEndTime])

    const handleEndChange = useCallback((e) => {
        if (e < startTime) {
            setStartTime(e)
            setEndTime(e)
        } else {
            setEndTime(e)
        }
    }, [startTime, setStartTime, setEndTime])

    if (startTime.getFullYear() === today.getFullYear()) {
        if (startTime.getMonth() === today.getMonth()) {
            if (startTime.getDate() === today.getDate()) {
                flag1 = true;
            }
        }
    }
    if (endTime.getFullYear() === today.getFullYear()) {
        if (endTime.getMonth() === today.getMonth()) {
            if (endTime.getDate() === today.getDate()) {
                flag2 = true;
            }
        }
    }

    const resetCreateBtn = () => {
        setBtnDisabled(false)
        setCreateBtnText('CREATE')
    }

    const handleCreateCampaign = useCallback(() => {

        if (name.toString().trim() === '') {
            alert('Name is required')
            return
        } else if (subdomain === '') {
            alert('Link name is required')
            return
        } else if (showFloorplan) {
            if (!fpBackground) {
                alert('Background image for floorplan required')
                return
            }
        }

        if (/^[a-zA-Z0-9- ]*$/.test(subdomain) === false) {
            alert('Subdomain should not contain special characters')
            return
        }

        if (collectAddress && surveyQuestion.trim() === '') {
            alert('Survey Question is Required')
            return
        }

        const campaign = {
            name,
            description,
            startTime: {
                year: startTime.getFullYear(),
                month: startTime.getMonth() + 1,
                day: startTime.getDate(),
                hour: startTime.getHours() > 12 ? startTime.getHours() - 12 : startTime.getHours(),
                minute: startTime.getMinutes(),
                PM: startTime.getHours() > 12 ? true : false,
            },
            endTime: {
                year: endTime.getFullYear(),
                month: endTime.getMonth() + 1,
                day: endTime.getDate(),
                hour: endTime.getHours() > 12 ? endTime.getHours() - 12 : endTime.getHours(),
                minute: endTime.getMinutes(),
                PM: endTime.getHours() > 12 ? true : false
            },
            timezoneOffset: Number(timeZone),   // making sure its a number
            createdBy: props.user.id,
            subdomain: subdomain.toLowerCase(),
            showLeaderboard,
            maxLevels: null,
            floorplan: showFloorplan ? { height, width, labels } : null,
            media: {
                cover: null,
                logo: fpBackground && showFloorplan ? fpBackground : null
            },
            collectAddress,
            surveyQuestion,
            hideDisplayTime,
            location: location ? JSON.stringify(location) : null,
            secretLocation: location ? secretLocation : null,
            earlyPayout: props.user.isStripeStandard ? true : false
        }

        setBtnDisabled(true)
        setCreateBtnText('CREATING...')

        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: isSubdomainAvailable,
                variables: {
                    subdomain: subdomain.toLowerCase()
                }
            })
            .then(res => {
                if (res.data.data.campaign.isSubdomainAvailable) {
                    fetchAPI
                        .post(API_ENDPOINTS.BASE_URL, {
                            query: createCampaign,
                            variables: {
                                campaign
                            }
                        })
                        .then(res1 => {
                            window.location.pathname = '/campaign/' + res1.data.data.campaign.create.id
                        })
                        .catch(err => {
                            console.log(err)
                            resetCreateBtn()
                        })
                } else {
                    alert('Subdomain already in use, please try another one')
                    resetCreateBtn()
                    return
                }
            })
            .catch(err => {
                alert('Subdomain already in use, try another one')
                resetCreateBtn()
            })
    }, [name, description, startTime, endTime, fpBackground, showFloorplan,
        timeZone, props, height, width, surveyQuestion, location, secretLocation,
        subdomain, showLeaderboard, labels, showFloorplan, collectAddress])

    // Construct data for floor chart
    useEffect(() => {
        const initData: any = [];
        initData.push({
            id: 'Available',
            data: []
        })
        for (let x = 0; x < width; x++) {
            for (let y = 0; y < height; y++) {
                const node = labels.find((item: any) => {
                    return item.x === x && item.y === y
                })
                if (node === undefined) {
                    initData[0].data.push({
                        x, y
                    })
                }
            }
        }
        labels.map((item: any) => {
            initData.push({
                id: item.label,
                data: [{ x: item.x, y: item.y }]
            })
        })
        setData(initData)
    }, [height, width, setData, labels, currNode])

    const CustomNode = useCallback(({
        node,
        x,
        y,
        size,
        color,
        blendMode,
        onMouseEnter,
        onMouseMove,
        onMouseLeave,
        onClick,
    }) => {
        const label: any = labels ? labels.find((i: any) => {
            return i.label.toString().trim() === node.data.serieId.toString().trim()
        }) : null

        let selected = false;
        if (currNode.x === node.data.x && currNode.y === node.data.y) {
            selected = true;
        }

        if (!label) {
            return (
                <g transform={`translate(${x},${y})`} style={{ zIndex: 15000000, opacity: 1 }}>
                    <circle
                        stroke={node.data.serieId === 'Available' ? "#242d51" : '#f1f1f1'} stroke-width="0.5"
                        fill-opacity={selected ? 1 : 0.4}
                        stroke-opacity={0.75}
                        r={size * 0.5}
                        fill={selected ? '#d63191' :
                            node.data.serieId === 'Available' ? '#f1f1f1' : '#242d51'}
                        style={{ mixBlendMode: blendMode, zIndex: 15000000, opacity: 1 }}
                        onMouseEnter={onMouseEnter}
                        onMouseMove={onMouseMove}
                        onMouseLeave={onMouseLeave}
                        onClick={onClick}
                    />
                </g>
            )
        }
        return (
            <g transform={`translate(${x},${y})`} style={{ zIndex: 15000000, opacity: 1 }}>
                <text
                    x={size * -1}
                    y={size * 0.5}
                    font-size='8px'
                    font-style='bold'
                    color='#1931b9'
                    font-color='#1931b9'
                    style={{ zIndex: 150, opacity: 1 }}
                >
                    {label.label.toUpperCase()}
                </text>
            </g>
        )
    }, [labels, currNode])

    return <div style={{ padding: '20px' }}>
        <Text
            label='Name'
            value={name}
            onChange={e => setName(e.target.value)}
        />
        <div style={{ paddingBottom: 15, marginTop: 4, marginBottom: 4 }}>
            <Label>
                Location (Optional)
            </Label>
            <div style={{ flexDirection: 'row', display: 'flex' }}>
                <div style={{ width: '90%' }}>
                    <GooglePlacesAutocomplete
                        selectProps={{
                            value: location,
                            onChange: setLocation,
                        }}
                        apiKey="AIzaSyCrggUEQEDx7yKV8XA5MmtS75eDwbnbRY8"
                    />
                </div>
                <div style={{ width: '10%', display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'right' }}>
                    {
                        location ?
                            <span onClick={() => setLocation(null)}>
                                <CloseCircleOutline />
                            </span> : null
                    }
                </div>
            </div>
            <div style={{ width: '100%', textAlign: 'left', paddingTop: 15 }}>
                <span style={{ paddingLeft: '20px' }}>
                    <Input
                        disabled={!location}
                        type="checkbox"
                        checked={secretLocation}
                        onChange={e => setSecretLocation(!secretLocation)}
                        style={{ height: 'auto' }}
                    />
                </span>
                <span style={{ paddingLeft: '5px' }}>
                    Secret Location
                </span>
                <Info>
                    Address will only be shared with your customers.
                </Info>
            </div>
        </div>
        <TextArea
            label='Description'
            placeholder='(Optional)'
            value={description}
            onChange={e => setDescription(e.target.value)}
        />
        <div style={{ marginTop: 4 }}>
            <Text
                label='Link Name'
                value={subdomain}
                onChange={e => setSubdomain((e.target.value.split(' ').join('')))}
            />
        </div>
        <Info>
            If you enter 'abc' for example, your selling link will be abc.isotopeticketing.com
        </Info>
        <br />
        <div style={{ paddingBottom: '20px' }}>
            <TimezoneSelect
                onChange={e => setTimeZone(Number(e.target.value))}
                value={timeZone}
                label="Time Zone"
            />
        </div>
        <div style={{ textAlign: 'left' }}>
            <div style={{ width: '100%', textAlign: 'left' }}>
                {/* <span style={{ paddingLeft: '20px' }}>
                    <Input
                        type="checkbox"
                        checked={!hideDisplayTime}
                        onChange={e => setHideDisplayTime(!hideDisplayTime)}
                        style={{ height: 'auto' }}
                    />
                </span> */}
                <span style={{ paddingLeft: '0px' }}>
                    Event Starts At
                </span>
            </div>
            {
                // hideDisplayTime ? null :
                <div style={{ width: '100%' }}>
                    <br />
                    <DatePicker
                        selected={startTime}
                        onChange={handleStartChange}
                        selectsStart={true}
                        startDate={startTime}
                        endDate={endTime}
                        minDate={new Date()}
                        minTime={flag1 ? new Date() : zero}
                        maxTime={now}
                        showTimeSelect={true}
                        timeFormat="HH:mm"
                        timeIntervals={15}
                        dateFormat="MMMM d, yyyy h:mm aa"
                        timeCaption="time"
                        style={{ width: '100%', border: 'none', backgroundColor: '#ebecf1' }}
                    />
                </div>
            }
            <p style={{ marginBottom: 20 }} />
            <div style={{ width: '100%' }}>
                <p style={{ color: '#242d51' }}>End Sales At</p>
                <DatePicker
                    selected={endTime}
                    onChange={handleEndChange}
                    selectsEnd={true}
                    startDate={startTime}
                    endDate={endTime}
                    minDate={startTime}
                    minTime={flag2 ? new Date() : zero}
                    maxTime={now}
                    showTimeSelect={true}
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    dateFormat="MMMM d, yyyy h:mm aa"
                    timeCaption="time"
                    style={{ width: '100%', border: 'none', backgroundColor: '#ebecf1' }}
                />
            </div>
        </div>
        {/* {
            props.user.isStripeStandard ?
                <div style={{ width: '100%', textAlign: 'left' }}>
                    <br />
                    <span style={{ paddingLeft: '20px' }}>
                        <Input
                            type="checkbox"
                            checked={earlyPayout}
                            onChange={e => setEarlyPayout(!earlyPayout)}
                            style={{ height: 'auto' }}
                        />
                    </span>
                    <span style={{ paddingLeft: '5px' }}>
                        Early Payout
                    </span>
                    <Info>
                        Enabling this option will only let the event owner receive the entire payout (including affiliate commissions).
                        You will also be responsible for refunds and disputes.
                        By default, regular payouts are initiated 3 business days after the end of the event and your affiliates will be paid out directly.
                    </Info>
                </div> : null
        } */}
        <div style={{ width: '100%', textAlign: 'left' }}>
            <br />
            <span style={{ paddingLeft: '20px' }}>
                <Input
                    type="checkbox"
                    checked={collectAddress}
                    onChange={e => setCollectAddress(!collectAddress)}
                    style={{ height: 'auto' }}
                />
            </span>
            <span style={{ paddingLeft: '5px' }}>
                Collect Additional Information (Optional)
            </span>
            <Info>
                By default, a customer's name, e-mail & phone number is collected.
            </Info>
        </div>
        {
            collectAddress ?
                <div>
                    <Text
                        value={surveyQuestion}
                        onChange={e => setSurveyQuestion(e.target.value)}
                        placeholder={'ex. Shipping Address'}
                    />
                </div>
                : null
        }
        <div style={{ width: '100%', textAlign: 'left' }}>
            <br />
            <span style={{ paddingLeft: '20px' }}>
                <Input
                    type="checkbox"
                    checked={showFloorplan}
                    onChange={e => setShowFloorplan(!showFloorplan)}
                    style={{ height: 'auto' }}
                />
            </span>
            <span style={{ paddingLeft: '5px' }}>
                Seating Layout
            </span>
            <Info>
                Map tables and sections to your own uploaded image. Create new ticket in 'Links & Tickets' to map tables.
            </Info>
        </div>
        {
            showFloorplan ?
                <div style={{ paddingBottom: '20px' }}>
                    <ImageUpload
                        imgSrc={fpBackground !== null ? fpBackground : 'https://platform.isotopeticketing.com/landing.png'}
                        onUpload={imgUrl => setFpBackground(imgUrl)}
                        background={true}
                    />
                    <div style={{ position: 'relative', marginTop: '10px' }}>
                        <div style={{ position: 'absolute' }}>
                            {
                                fpBackground ?
                                    <img src={fpBackground}
                                        onLoad={e => onImgLoad(e)}
                                        style={{ width: '100%', opacity: 0.75, zIndex: 30, borderRadius: '10px' }}
                                    /> : null
                            }
                        </div>
                        <div style={{ position: 'absolute', height: fpBackground ? imageHeight : height * 25, width: '100%', opacity: 1, zIndex: 35 }}>
                            <ResponsiveScatterPlot
                                data={data}
                                margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
                                enableGridX={false}
                                enableGridY={false}
                                // blendMode="darken"
                                axisTop={null}
                                axisRight={null}
                                axisLeft={null}
                                axisBottom={null}
                                onClick={(n, e) => undefined}
                                colors={{ scheme: 'paired' }}
                                renderNode={CustomNode}
                                tooltip={({ node }: any) => (
                                    <div
                                        className='blur-safari'
                                        style={{
                                            padding: '10px',
                                            color: '#242d51',
                                            borderRadius: '15px',
                                            backdropFilter: 'blur(20px)',
                                            border: '0.4px solid #f1f1f1',
                                            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.02), 0 1px 3px rgba(0, 0, 0, 0.02)'
                                        }}
                                    >
                                        <strong>
                                            {node.data.serieId}
                                        </strong>
                                    </div>
                                )}
                            />
                        </div>
                    </div>
                </div>
                : null
        }
        <div style={{
            width: '100%', textAlign: 'left', paddingLeft: '20px',
            marginTop: showFloorplan ? (fpBackground ? imageHeight + 25 : height * 26) : '0px', paddingBottom: '20px', zIndex: 30
        }}>
            <br />
            <Input
                type="checkbox"
                checked={agreed}
                onChange={e => setAgreed(!agreed)}
                style={{ height: 'auto' }}
            />
            <span style={{ paddingLeft: '5px' }}>
                I agree to the &nbsp;
                <span style={{ cursor: 'pointer', textDecoration: 'underline' }}>
                    <a target="_blank" href="../../../termsandconditions.pdf">Terms and Conditions</a>
                </span>
                <br /></span>
        </div>
        {/* {
            error ?
                <Error content={errorMessage} />
                : null
        } */}
        <div style={{ width: '100%', textAlign: 'center', paddingTop: '20px' }}>
            <button className='new-button-save' onClick={() => handleCreateCampaign()} disabled={!agreed || btnDisabled}>
                {createBtnText}
            </button>
        </div>
        <div style={{ width: '100%', textAlign: 'center', paddingTop: '10px' }}>
            <button className='new-button-cancel' onClick={() => closeModal()}>
                CANCEL
            </button>
        </div>
    </div >
}

const mapStateToProps = state => ({
    user: UserDucks.getUser(state),
});

export default connect(mapStateToProps)(CreateCampaign);


// WEBPACK FOOTER //
// ./src/pages/campaign/CreateCampaign.tsx